/* Elico - subscription free-refill trigger (per product).
   For each starter kit page: when the buybox "Abonner og spar" option is selected, apply the
   product's subscription-only discount code (native Shopify, appliesOnSubscription only) so the
   refill is free on the subscription line. A one-time purchase never triggers it.
   Body wash additionally gets a scent dropdown (which refill scent is added free), gated to
   in-stock scents, and a custom add-to-cart that adds kit + chosen scent as a subscription. */
(function () {
  var CONFIG = {
    'handsoap-starterkit': { code: 'STARTERKIT-REFILL' },
    'bodywash-starterkit': {
      code: 'BODYWASH-REFILL',
      refillHandle: 'body-wash-refills',
      scents: [
        { id: 59515865006366, name: 'Rose & klementin' },
        { id: 59515865039134, name: 'Kokos & vanilje' }
      ]
    }
  };

  function handle() {
    var m = (location.pathname || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  var cfg = CONFIG[handle()];
  if (!cfg) return;
  var CODE = cfg.code;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function subSelected() {
    var el = document.querySelector('[data-ss][data-type="sub"]');
    return !!(el && el.classList.contains('is-selected'));
  }
  function openCartDrawer(routes) {
    var d = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
    if (d && typeof d.getCart === 'function') {
      try { d.getCart(); } catch (e) {}
      setTimeout(function () {
        try { if (typeof d.openCartDrawer === 'function') d.openCartDrawer(); else if (typeof d.open === 'function') d.open(); }
        catch (e) { window.location.href = routes + 'cart'; }
      }, 450);
      return;
    }
    window.location.href = routes + 'cart';
  }
  function refreshDrawer() {
    var d = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
    if (d && typeof d.getCart === 'function') { try { d.getCart(); } catch (e) {} }
  }
  var applying = false, appliedOnce = false;
  function applyCode(then) {
    if (applying) { if (then) then(); return; }
    applying = true;
    fetch(root() + 'discount/' + encodeURIComponent(CODE), { credentials: 'same-origin' })
      .then(function () { applying = false; appliedOnce = true; if (then) then(); })
      .catch(function () { applying = false; if (then) then(); });
  }

  // Pre-apply the code as soon as the subscribe option is chosen (both products).
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-ss][data-type="sub"]') && !appliedOnce) applyCode();
  }, true);

  if (!cfg.scents) {
    // ---- Hand soap: native buybox adds the single refill; we just ensure the code + drawer refresh.
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var atc = t.closest('[data-ebb-atc]');
      if (atc && subSelected()) { applyCode(function () { setTimeout(refreshDrawer, 250); }); setTimeout(refreshDrawer, 900); }
    }, true);
    setTimeout(function () { if (subSelected() && !appliedOnce) applyCode(); }, 800);
    return;
  }

  // ---- Body wash: scent dropdown + custom subscribe add.
  var bound = false, adding = false;
  function injectScent(subCard, scents) {
    if (subCard.querySelector('[data-scent]')) return;
    var cadWrap = subCard.querySelector('.ebb__cadence');
    var wrap = document.createElement('div');
    wrap.className = 'ebb__cadence';
    wrap.setAttribute('data-scent-wrap', '');
    var sel = document.createElement('select');
    sel.setAttribute('data-scent', '');
    sel.setAttribute('aria-label', 'Velg duft på gratis refill');
    scents.forEach(function (s) {
      var o = document.createElement('option');
      o.value = String(s.id); o.textContent = s.name; sel.appendChild(o);
    });
    wrap.appendChild(sel);
    if (cadWrap && cadWrap.parentNode) cadWrap.parentNode.insertBefore(wrap, cadWrap);
    else subCard.appendChild(wrap);
  }
  function doBodywashAdd() {
    if (adding) return; adding = true;
    var routes = root();
    var kit = document.querySelector('[data-variant-id]');
    var qtyEl = document.querySelector('[data-quantity]');
    var cad = document.querySelector('[data-cadence]');
    var scent = document.querySelector('[data-scent]');
    var kitId = kit && kit.value;
    var qty = (qtyEl && parseInt(qtyEl.value, 10)) || 1;
    var items = [{ id: kitId, quantity: qty }];
    if (scent && scent.value && cad && cad.value) {
      items.push({ id: parseInt(scent.value, 10), quantity: 1, selling_plan: parseInt(cad.value, 10) });
    }
    fetch(routes + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        adding = false;
        if (res.ok) { applyCode(function () { setTimeout(function () { openCartDrawer(routes); }, 150); }); }
        else { console.warn('add failed', res.d); alert((res.d && res.d.description) || 'Kunne ikke legge i handlekurv.'); }
      }).catch(function (err) { adding = false; console.warn(err); });
  }
  function bindIntercept() {
    if (bound) return; bound = true;
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var atc = t.closest('[data-ebb-atc]');
      if (!atc) return;
      if (!subSelected()) return;              // "Kjøp én gang" -> let native add the kit only
      e.preventDefault(); e.stopImmediatePropagation();
      doBodywashAdd();
    }, true);
  }
  function initBodywash() {
    var subCard = document.querySelector('.ebb__sub[data-type="sub"]');
    if (!subCard) return false;               // subscribe block not rendered (waitlist / OOS) -> nothing to do
    fetch(root() + 'products/' + cfg.refillHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var avail = {};
        (p.variants || []).forEach(function (v) { avail[v.id] = v.available; });
        var inStock = cfg.scents.filter(function (s) { return avail[s.id]; });
        if (inStock.length === 0) { var blk = subCard.closest('.ebb__block'); if (blk) blk.style.display = 'none'; return; }
        injectScent(subCard, inStock);
        bindIntercept();
      })
      .catch(function () { injectScent(subCard, cfg.scents); bindIntercept(); });
    return true;
  }
  // Try now and shortly after load (buybox renders in normal flow).
  if (!initBodywash()) setTimeout(initBodywash, 600);
  setTimeout(initBodywash, 1500);
})();
